'use strict';

angular.module('app').directive('paymentInfo', function () {
  return {
    restrict: 'A',
    templateUrl: window.templatePath ? window.templatePath + 'templates/_payment-schedule.html' : '../templates/_payment-schedule.html',
    scope: {
      paymentInfo: '=',
      currency: '=',
      currencyToCharge: '=',
      amountTotal: '=',
    },
  };
});
